// Generated by CoffeeScript 1.9.3
var PaddingLeft, _Length,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

_Length = require('./_Length');

module.exports = PaddingLeft = (function(superClass) {
  extend(PaddingLeft, superClass);

  function PaddingLeft() {
    return PaddingLeft.__super__.constructor.apply(this, arguments);
  }

  return PaddingLeft;

})(_Length);



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/renderKid/styles/rule/declarationBlock/PaddingLeft.js
// module id = 396
// module chunks = 0